export default {
  ['loadForm'](state, payload) {
    state.form.company = payload.company;
    state.form.name = payload.name;
    state.form.email = payload.email;
  },
};
